import useWindowWidth from './useWindowWidth';
import { VIEWPORT_CONSTANTS } from '../constants/viewportConstants';
/**
 * Single source of truth for mobile viewport detection in converse-lib.
 * Prefer useIsMobileViewContext() when inside IsMobileViewProvider.
 */
const useIsMobileView = () => {
    const windowWidth = useWindowWidth();
    return windowWidth <= VIEWPORT_CONSTANTS.MOBILE_BREAKPOINT;
};
export default useIsMobileView;
//# sourceMappingURL=useIsMobileView.js.map